/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 * 
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
  bubbles: true
}));

$(document).ready(function(){
  $('.ProductForm__AddToCart').on('click', function(){
    
    $('.ProductForm__AddToCart').find('span').removeClass("fadeInDown").addClass('animated zoomOut');
    $('.ProductForm__AddToCart').find('.checkmark').addClass('checkmark-active');
  });
  
  $(document).on('click', 'button[name="checkout"]', function(){
    $(this).addClass('hs-loading-btn');
    setTimeout(function(){
      $('button[name="checkout"]').removeClass('hs-loading-btn');
    }, 2000);
  });
});

document.addEventListener('product:added', function(event) {
  
  setTimeout(function(){
    $('.ProductForm__AddToCart').find('.checkmark').removeClass('checkmark-active');
    $('.ProductForm__AddToCart').find('span').removeClass('zoomOut').addClass('fadeInDown');
  }, 1000);
  checkProtection();
});

$(function() {
  if($('body').hasClass('template-product')){
  if($(window).width() < 1008){
    $(window).scroll(function() {
      var scroll = $(window).scrollTop();
      var windowH = $(window).height();
      var objectSelect = $(".shopify-section-product-recommendations");
      var objectPosition = objectSelect.offset().top;
	  if(objectPosition == 0){
        objectPosition = 2000;
      }
      var h = $('.sticky_button').height();
      scroll = scroll+windowH-115;
     //removing sticky as button has made sticky permanently. 
      /*if (scroll >= objectPosition) {
        $('.sticky_button').addClass('remove-sticky');
      }else{
        $('.sticky_button').removeClass('remove-sticky');
      }/*
    });
  }
  
  if($(window).width() > 1007){
    $(window).scroll(function() {
      var scroll = $(window).scrollTop();
      var windowH = $(window).height();
      var objectSelect1 = $(".sticky_bar");
      var objectSelect2 = $("#shopify-section-product-recommendations");
      var objectPosition1 = objectSelect1.offset().top;
      var objectPosition2 = objectSelect2.offset().top;
      var h = $('.sticky_button').height();
      var scroll1 = scroll+40;
      var scroll2 = scroll+windowH-115;

      if(scroll2 >= objectPosition2){
        //$('.desktop-sticky').removeClass('add-sticky');
      }else{
        if (scroll >= objectPosition1) {
          //$('.desktop-sticky').addClass('add-sticky');
        }else{
          //$('.desktop-sticky').removeClass('add-sticky');
        }
      }
      
      /*if (scroll >= objectPosition2) {
        $('.sticky_button').addClass('remove-sticky');
      }
      
      if (scroll >= objectPosition1) {
        $('.sticky_button').removeClass('remove-sticky');
      }

      if (scroll <= objectPosition2) {
        $('.sticky_button').removeClass('remove-sticky');
      }*/
    });
  }
  
  /*
  var scroll = $(window).scrollTop();
  
  var objectSelect = $(".sticky_bar");
  var objectPosition = objectSelect.offset().top;
  
  scroll = scroll;
  if (scroll <= objectPosition) {
    $('.sticky_button').addClass('remove-sticky');
  }else{
    $('.sticky_button').removeClass('remove-sticky');
  }*/
  }
  });

checkProtection();

function checkProtection(){
  var cartContents = fetch('/cart.js')
  .then(response => response.json())
  .then(data => { 
    var hasProtection = false;
    $(data.items).each(function(k,v){
      if(v.handle == "12-months-insurance"){
        hasProtection = true;
      }
    });
    if(hasProtection == true){
      $(this).parents('.drawer-recom').hide();
    }else{
      $(this).parents('.drawer-recom').show();
    }
    return data  
  });
}

document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant; // Gives you access to the whole variant details
  var previousVariant = event.detail.previousVariant;
  $('.meta-variant-stock').text(variant.inventory_quantity)

  $('.custom-limited-wrapper').hide();
  $('.custom-limited-wrapper[id="'+variant.id+'"]').show();
  
  if(previousVariant.id != variant.id ){
    if (variant.available ){
      var percent= $('#'+variant.id).data('percent');
      var width=100;
      var fn=setInterval(move,2);
      function move(){
        if (width<=percent){
          $('#'+variant.id).find('.bar-inner').css('width', percent+'%');
          clearInterval(fn);
        } else {  
          $('#'+variant.id).find('.bar-inner').css('width', width+'%');
          width=width-0.2;
        }
      }
    }else{
      $('div[id="'+variant.id+'"]').find('.custom-limited-text').css('display','none');
      $('div[id="'+variant.id+'"]').find('.custom-sold-out').css('display','block');

      var percent= 0;
      var width=100;
      var fn=setInterval(move,2);
      function move(){
        if (width<=percent){
          $('#'+variant.id).find('.bar-inner').css('width', percent+'%');
          clearInterval(fn)
        } else {
          $('#'+variant.id).find('.bar-inner').css('width', width+'%');
          width=width-0.2;
        }
      }
    }
  }
});

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function checkCookie() {
  let user = getCookie("username");
  if (user != "") {
    alert("Welcome again " + user);
  } else {
    user = prompt("Please enter your name:", "");
    if (user != "" && user != null) {
      setCookie("username", user, 365);
    }
  }
}

$(document).ready(function(){
  if(getCookie('HasAcceptCookies') == ""){
    if($('.cookie_wrapper').length > 0){
      setTimeout(function(){
        $('.cookie_wrapper').addClass('fade-in');
      }, 2000);
      
    }
  }
  $('.Button--Accept-Cookies').on('click', function(){
    $('.cookie_wrapper').removeClass('fade-in');
    setCookie('HasAcceptCookies', 'yes', 365);
  });
  
  setInterval(function(){
    $('.Cart__Checkout').toggleClass('Hsshake');
  }, 2000);
  
  //$('.Cart__Checkout').addClass('Hsshake');
  
  $(document).on("click", ".cart_drawer_add", function(e){
    e.preventDefault();
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    var cart_url = $(this).attr('href');
    jQuery.ajax({
      type: 'POST',
      url: cart_url,
      success: function(dataObj) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));

        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: dataObj.variant_id,
            quantity: dataObj.quantity
          }
        }));        
      },

      error: function(errorObj) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));

        //var addToCartButton = $(this).find('.ProductForm__AddToCart');
        var errorMessageElement = document.createElement('span');
        errorMessageElement.className = 'ProductForm__Error Alert Alert--error';

//         errorMessageElement.innerHTML = errorObj.responseJSON.description;
//         $(addToCartButton).hide();
//         $(addToCartButton).after(errorMessageElement);
//         setTimeout(function () {
//           errorMessageElement.remove();
//           $(addToCartButton).show();
//         }, 2500);
      }
    });

    return false;
  });
  
  if($('.mobile_video iframe').length > 0){
    $('.mobile_video iframe').attr("src", $('.mobile_video iframe').attr("src").replace("autoplay=0", "autoplay=1"));
  }
  
  
  
  $('.FrameSwatchList .SizeSwatch__Radio').on('change', function(){
    var val = $(this).val();
    if(val == 'No Frame'){
      $('.product-frame').html('');
      $('.Product__SlideItem--image[data-media-position="1"] img').css('padding', '0');
    }else{
      var image = $('.product-frame').hasClass("portrait") ? $(this).data('portrait') : $(this).data('landscap');
      if($('.product-frame').hasClass("portrait")){
        var p = '0px';
        if(val == 'Gold Frame'){
           p = '55px';
        }
        if(val == 'White Frame'){
           p = '20px';
        }
        if(val == 'Black Frame'){
           p = '68px';
        }
        $('.Product__SlideItem--image[data-media-position="1"] img').css('padding', '4.5px 0px');
       // $('.portrait').html('<img class="frame-img" src="https://cdn.shopify.com/s/files/1/0073/9193/6569/files/portrait-frame.png?v=1629527780">');
      }else{
        if(val == 'White Frame'){
          $('.Product__SlideItem--image[data-media-position="1"] img').css('padding', '4.5px 0px');
        }else{
          $('.Product__SlideItem--image[data-media-position="1"] img').css('padding', '4.5px 0px');
        }
        //$('.product-frame').html('<img class="frame-img" src="https://cdn.shopify.com/s/files/1/0073/9193/6569/files/landscape-frame.png?v=1629527770">');
      }
      $('.product-frame').html('<img class="frame-img" src="'+image+'">');
      $('.Product__Slideshow').flickity().flickity( 'select', 0 );
    }
  });
  
});

// document.addEventListener("DOMContentLoaded", function() {
//   var endlessScroll = new Ajaxinate({
//     container: '#Huratips-Loop',
//     pagination: '#Huratips-Pagination'
//   });
// });

$(document).ready(function() {

  $('.sm_open').on('click', function(){
    var modal = $(this).attr('data-modal');
    var modaloverlaycolor = $(this).attr('data-overlay');
    var modaleffect = $(this).attr('data-effect');
    var modalheader = $(this).attr('data-header');
    var modalheadertype = $(this).attr('data-header-type');
    var modalcontent = $(this).attr('data-content');
    var modaliconside = $(this).attr('data-icons');
    var modalwrappercolor = $(this).attr('data-wrapper-color');

    $('#' + modal).addClass(modaloverlaycolor);
    $('#' + modal + ' .sm_content').addClass(modaleffect);
    $('#' + modal + ' .sm_content .sm_header').html(modalheader);
    $('#' + modal + ' .sm_content .sm_header').addClass(modalheadertype);
    $('#' + modal + ' .sm_content .sm_area_all').html(modalcontent);
    $('#' + modal + ' .sm_icon_menu').addClass(modaliconside);
    $('#' + modal + ' .sm_content').addClass(modalwrappercolor);
    $('#' + modal).fadeIn().css("display", "flex");
    setTimeout(function(){
      $('#'+modal + ' .sm_content').addClass('show');
    }, 400);        
  });

  $('.sm_close').on('click', function(){
    var $modal = $(this).parents('.slim_modal');
    closeModal($modal);  
  });

  $('.slim_modal').on('click', function(e) {
    if (e.target !== this)
      return;
    var $modal = $(this);
    closeModal($modal);
  });

  function closeModal($modal) {
    $modal.find('.sm_content').removeClass('show');
    setTimeout(function(){
      $modal.removeClass('red green tan none');
      $modal.find('.sm_content').removeClass('red green tan');
      $modal.find('.sm_icon_menu').removeClass('is_right is_left');
      $modal.find('.sm_header').removeClass('detached');
      $modal.fadeOut();
    }, 400);
  }
});


/* Accordion */

$("#accordion .mobile_view > h3").click(function(){

  if(false == $(this).next().is(':visible')) {
    $('#accordion ul').slideUp(300);
  }

  var classnm = $(this).parent('.mobile_view').attr("class");
  // Line Added to remove the active class from all 'li'
  $('#accordion .mobile_view').removeClass('active');
  // Line Added to remove the blank attribute of class from all 'li'
  $('#accordion .mobile_view[class=""]').removeAttr('class');
  // Line Added to add the active class in current 'li'

  $(this).next().slideToggle(300);

  if(classnm == "undefined" || classnm == "" || classnm == undefined){
    $(this).parent('.mobile_view').addClass('active');
  }
});

$('#accordion ul:eq(0)').show();


/* pro slider */

/* Slick */

// $('.product-list').slick({
//   arrows: true,
//   dots: false,
//   speed: 300,
//   slidesToShow: 4,
//   slidesToScroll: 4,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 3
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         arrows: true,
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         arrows: true,
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//     // You can unslick at a given breakpoint now by adding:
//     // settings: "unslick"
//     // instead of a settings object
//   ]
// });


// $('.feature_coll_slider1').slick({
//   arrows: true,
//   dots: false,
//   speed: 300,
//   slidesToShow: 2,
//   slidesToScroll: 2,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 900,
//       settings: {
//         arrows: true,
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         arrows: true,
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//     // You can unslick at a given breakpoint now by adding:
//     // settings: "unslick"
//     // instead of a settings object
//   ]
// });

$(document).ready(function () {

  var result;
  var p;

  if (window.performance.navigation) {
      result=window.performance.navigation;
      if (result==255){result=4} // 4 is my invention!
  }

  if (window.performance.getEntriesByType("navigation")){
      p=window.performance.getEntriesByType("navigation")[0].type;

      if (p=='navigate'){result=0}
      if (p=='reload'){result=1}
      if (p=='back_forward'){result=2}
      if (p=='prerender'){result=3} //3 is my invention!
  }
  //   Result description:
  // 0: clicking a link, Entering the URL in the browser's address bar, form submission, Clicking bookmark, initializing through a script operation.
  // 1: Clicking the Reload button or using Location.reload()
  // 2: Working with browswer history (Bakc and Forward).
  // 3: prerendering activity like <link rel="prerender" href="//example.com/next-page.html">
  // 4: any other method.

  var $this;
  var totalPages;
  var currentPage;

  var loadMoreKeys = ['pLength', 'pLengthportrait', 'pLengthlanscape', 'totalPages', 'currentPage', '$this', 'scrollpos', 'Productlist', 'nextUrl', 'location'];
  function clearLoadMoreState() {
    loadMoreKeys.forEach(function(key) { localStorage.removeItem(key); });
  }

  // Restore the products loaded via "Show more" only when coming back to the same
  // collection with the browser Back/Forward buttons. On any other visit the saved
  // list is stale (products may have been added since) and would hide the button.
  var loc = localStorage.getItem("location");
  var restoreLoadMore = result == 2 && loc && window.location.href == loc && localStorage.getItem('Productlist');
  if (!restoreLoadMore) {
    clearLoadMoreState();
  }

  var pLengthLoad = $('.ProductList .Grid__Cell').length;
  var pLengthLoadportrait = $('.ProductList .Grid__Cell .ProductItem:not(.Horizontal--ProductItem)').length;
  var pLengthLoadlanscape = $('.ProductList .Grid__Cell .ProductItem.Horizontal--ProductItem, .ProductList .Grid__Cell .ProductItem.Frame--ProductItem').length;

  if (restoreLoadMore) {
    $('.ProductList').replaceWith(localStorage.getItem('Productlist'));
    pLengthLoad = $('.ProductList .Grid__Cell').length;
    pLengthLoadportrait = $('.ProductList .Grid__Cell .ProductItem:not(.Horizontal--ProductItem)').length;
    pLengthLoadlanscape = $('.ProductList .Grid__Cell .ProductItem.Horizontal--ProductItem, .ProductList .Grid__Cell .ProductItem.Frame--ProductItem').length;

    var cpage = localStorage.getItem("currentPage");
    if (cpage) {
      $('[data-current-page]').val(cpage);
      if ($('[data-next-url]').length) {
        $('[data-next-url]').val($('[data-next-url]').val().replace(/page=[0-9]+/,'page='+(parseInt(cpage)+1)));
      }
    }

    // Keep the live total page count and only hide the button when every page is loaded.
    if (parseInt(cpage) >= parseInt($('[data-total-pages]').val())) {
      $('.show-more-button').hide();
    }
  }

  $('#total-current-page').html(pLengthLoad);
  $('#total-current-page-portrait').html(pLengthLoadportrait);
  $('#total-current-page-landscape').html(pLengthLoadlanscape);
  $('#file').html(pLengthLoad);
  $('#file-portrait').html(pLengthLoadportrait);
  $('#file-landscape').html(pLengthLoadlanscape);
  $('#file').val(pLengthLoad);
  $('#file-portrait').val(pLengthLoadportrait);
  $('#file-landscape').val(pLengthLoadlanscape);

  $('.js-load-more').on('click', function(){
    console.log('here');
    $this =$(this);
    totalPages = parseInt($('[data-total-pages]').val());
    currentPage = parseInt($('[data-current-page]').val());
    $this.attr('disabled', true);
    $this.find('[loader]').removeClass('hide');
    currentPage = currentPage+1;
    var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
    $('[data-current-page]').val(currentPage);
    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function(responseHTML){
        $('[data-next-url]').val($(responseHTML).find('[data-next-url]').val());
        $('.ProductList').append($(responseHTML).find('.ProductList').html());
        setTimeout( function() {
          document.documentElement.style.setProperty('--announcement-bar-height', `${Math.round(document.querySelector('.announcement-bar').clientHeight)}px`);
        }, 100)
        var pLength = $('.ProductList .Grid__Cell').length;
        var pLengthportrait = $('.ProductList .Grid__Cell .ProductItem:not(.Horizontal--ProductItem)').length;
        var pLengthlanscape = $('.ProductList .Grid__Cell .ProductItem.Horizontal--ProductItem, .ProductList .Grid__Cell .ProductItem.Frame--ProductItem').length;
        $('#total-current-page').html(pLength);
        $('#total-current-page-portrait').html(pLengthportrait);
        $('#total-current-page-landscape').html(pLengthlanscape);
        $('#file').html(pLength);
        $('#file-portrait').html(pLengthportrait);
        $('#file-landscape').html(pLengthlanscape);
  		  $('#file').val(pLength);
        $('#file-portrait').val(pLengthportrait);
        $('#file-landscape').val(pLengthlanscape);
        localStorage.setItem('pLength', pLength);
        localStorage.setItem('pLengthportrait', pLengthportrait);
        localStorage.setItem('pLengthlanscape', pLengthlanscape);
        localStorage.setItem('nextUrl', nextUrl);
      },
      complete: function() {
        if(currentPage <= totalPages) {
          $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
        } 
        if(currentPage >= totalPages) { 
          $('.show-more-button').hide();
          //hiding below line as client asked to hide No more product tab
          //$this.attr('disabled', true); $this.find('[load-more-text]').text('No more product').removeClass('hide'); $this.find('[loader]').addClass('hide');
        } 
        localStorage.setItem('scrollpos', window.scrollY);
        localStorage.setItem("totalPages",totalPages);
        localStorage.setItem("currentPage",currentPage);
        localStorage.setItem('$this',  $this.prop('outerHTML'));
        localStorage.setItem('Productlist', $('.ProductList').prop('outerHTML'));
        localStorage.setItem('location', window.location.href);
      }
    })
  });

  $('.onclick_cart_price_hide').on('click', function(){
    $('.onclick_cart_price_hide').hide();
    $('.onclickShow_show_cart_loader').css('display', 'flex');
  });

  $('#drawer_close_btn, .PageOverlay.is-visible').on('click', function(){
    $('.onclick_cart_price_hide').show();
    $('.onclickShow_show_cart_loader').hide();
  });

  $(document).on('click', '#drawer_close_btn, .PageOverlay.is-visible', function(){
    $('.onclick_cart_price_hide').show();
    $('.onclickShow_show_cart_loader').hide();
  });

  $(document).on('click', '.PageOverlay', function(){
    $('.onclick_cart_price_hide').show();
    $('.onclickShow_show_cart_loader').hide();
  });

});